module.exports = __webpack_public_path__ + "static/media/start_stroking_again.7117c943.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/start_stroking_again.wav
// module id = 518
// module chunks = 0